import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import ContentCard from "./ContentCard";

function Rektorat() {
  const data = [
    {
      name: "Rizayev Kamal Saidakbarovich",
      job: "Rektor",
      email: "rektor@pharmi.uz",
      number: " (71) 256-37-38",
      level: 'Tibbiyot fanlari doktori',
      time: "Seshanba, Payshanba",
      clock: "15:00-17:00",
      img: "/rektorat/1.png",
    },
    {
      name: "Yuldashev Zokirdjon Abidovich",
      job: " O‘quv ishlar bo‘yicha prorektor",
      email: "educat@pharmi.uz",
      number: "(71) 256-06-62",
      level: 'Farmatsevtika fanlari doktori',
      time: "Dushanba, Shanba ",
      clock: "15:00-17:00",
      img: "/img/employed/YuldashevZokirjon.jfif",
    },
    {
      name: "Sagatov Ibroxim Raufovich",
      job: "Yoshlar masalalari va ma’naviy-ma’rifiy ishlar bo‘yicha prorektor",
      email: "ibroxim@.email.com",
      number: "(71) 256-42-88",
      level: 'Falsafa fanlari doktori (PhD)',
      time: "Dushanba-Juma",
      clock: "15:00-18:00",
      img: "/img/employed/SagatovIbroxim.jfif",

    },
    {
      name: "Normaxamatov Nodirali Soxobataliyevich",
      job: "Ilmiy ishlar va innovatsiyalar bo‘yicha prorektor",
      email: "normakhamatov@pharmi.uz",
      number: " (71) 256-39-54",
      level: 'Kimyo fanlar doktori',
      time: "Seshanba, Payshanba",
      clock: "15:00-18:00",
      img: "/img/employed/NormaxamatovNodirali.jfif",
    },
    {
      name: "Sobirov Shoyadbek Kurbonaliyevich",
      job: "  Ishlar boshqarmasi boshlig‘i",
      email: "ish.bosh@pharmi.uz",
      number: " (71) 256-39-62",
      level: ' Ilmiy daraja/unvon',
      time: "Juma",
      clock: "15:00-18:00",
      img: "/img/employed/SobirovShoyadbek.jfif",
    },
    {
      name: "Ganiyeva Xilola Gayratovna",
      job: "Amaliyot ishlari bo'yicha prorektor",
      email: "ish.bosh@pharmi.uz",
      number: " +998909688656",
      level: 'khilolaganieva@pharmi.uz',
      time: " Chorshanba, Shanba",
      clock: "15:00-18:00",
      img: "/img/employed/GaniyevaHilola.jpg",
    },
    
  ]
  return (
    <div>
      <Navbar />

      <div className="body__rektorat">
        <div className="title">
            <h1>Rektorat</h1>
        </div>
        {
          data.map(item => <ContentCard data={item}/>)
        }
        
      </div>
      <Footer />
    </div>
  );
}

export default Rektorat;
